
/**
 *POS 操作日志
 *
 * @export
 * @class AddLogProcessor
 * @auther tuzha
 */
import OperationLogApi from '../../api/OperationLogApi'
export class AddLogProcessor {
    static execute(title, docno, description) {
        try{
          OperationLogApi.addPosLog(title, docno, description);
        }
        catch (e) {
            console.error('操作日志接口调用异常');
        }
       
    }
}